import React from 'react';
import { Package } from 'phosphor-react';
import colors from 'Exports/colors.scss';

const Tag = ({ color, description }) => {
  return (
    <div className="in-stock-tag">
      <Package color={color} />
      <span>{description}</span>
    </div>
  );
};

const ProductInStockTag = (product) => {
  const {
    isInStock, //totalstock
    isExternalStock,
    isInternalStock,
    externalDescription,
    internalDescription,
    stockStatusDescription,
    internalStockBelowThreshold,
  } = product;

  return !isInStock ? (
    <Tag color={colors.error} description={stockStatusDescription} />
  ) : (
    <>
      {isInternalStock && (
        <Tag color={colors.success} description={internalDescription} />
      )}
      {internalStockBelowThreshold && isExternalStock && (
        <Tag color={colors.warning} description={externalDescription} />
      )}
    </>
  );
};

export default ProductInStockTag;
